<style scoped>
  .expand-row{
    margin-bottom: 16px;
    line-height: 26px;
  }
</style>
<template>
  <div style="margin: -10px -30px -30px">
    <Row class="expand-row">
      <Col span="8" v-if="row.addresser">
        <span class="expand-key">收件人: </span>
        <span class="expand-value">{{ row.addressee }}</span>
      </Col>
      <Col span="8" v-if="row.payment">
        <span class="expand-key">付款方式: </span>
        <span class="expand-value">{{ row.payment }}</span>
      </Col>
      <Col span="8" v-if="row.addresser">
        <span class="expand-key">寄件人: </span>
        <span class="expand-value">{{ row.addresser }}</span>
      </Col>
      <Col span="8" v-if="row.contact">
        <span class="expand-key">联系方式: </span>
        <span class="expand-value">{{ row.contact }}</span>
      </Col>
      <Col span="8" v-if="row.agent_name">
        <span class="expand-key">代收人: </span>
        <span class="expand-value">{{ row.agent_name }}</span>
      </Col>
      <Col span="8" v-if="row.receive_time">
        <span class="expand-key">领取时间: </span>
        <span class="expand-value">{{ row.receive_time }}</span>
      </Col>
      <Col span="8" v-if="row.department">
        <span class="expand-key">部门: </span>
        <span class="expand-value">{{ row.department }}</span>
      </Col>
      <Col span="24">
        <span class="expand-key">邮寄地址: </span>
        <span class="expand-value">{{ row.address }}</span>
      </Col>
      <Col span="24">
        <span class="expand-key">发件事由及发件物品: </span>
        <span class="expand-value">{{ row.content }}</span>
      </Col>
    </Row>
  </div>
</template>
<script>
  export default {
    props: {
      row: Object
    }
  }
</script>